import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-msg-ico",
  "use": "icon-msg-ico-usage",
  "viewBox": "0 0 16 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 13\" id=\"icon-msg-ico\">\r\n<style type=\"text/css\">\r\n\t#icon-msg-ico .st0{fill:#A2AAAD;}\r\n</style>\r\n<path class=\"st0\" d=\"M8,7l6-3.5V11H2V3.6L8,7z M8,5L2.9,2h10.3L8,5z M0,13h16V0H0V13z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol